import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { formatHtml } from '../../utils/getFields'
import FileInfo from '../../elements/files/FileInfo'
import CasePreview from "./preview/CasePreview";
import TestPreview from "./preview/TestPreview";
import Cookies from 'js-cookie'

const styles = () => createStyles({
  previewButtonWrap: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
  },
  wrap: {
    display: 'flex',
    alignItems: 'baseline'
  },
  numeric: {
    marginRight: '10px'
  },
  title: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
})

const SegmentWatch = ({
  classes,
  segment,
  type,
  segmentId
}: any) => {
  const isCase = type === 'case'
  const { task, answers, questions } = segment

  /**
   * Открывает preview сегмента.
   */
  const openPreview = () => {
    const baseUrl = isCase ? process.env.REACT_APP_API_CASE_URL : process.env.REACT_APP_API_TEST_URL
    const token = Cookies.get('token')
    const url = baseUrl + '/preview/' + segmentId + '/' + token
    window.open(url, '_blank')
  }

  return (
    <>
      <div className={classes.previewButtonWrap}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => openPreview()}
        >
          Предварительный просмотр
        </Button>
      </div>
    </>
  )
}

export default withStyles(styles)(SegmentWatch)
